<template>
    <div class="flex flex-wrap flex-col justify-end md:justify-evenly pb-20 md:pb-0">
        <h5 class="text-sm md:text-base text-center text-black bg-gray-400 rounded-md p-3 w-full md:max-w-2xl">
            {{ question.attributes.choices.top }}
        </h5>
        <div class="w-full max-w-sm md:max-w-2xl mt-20 md:mt-0">
            <h4 class="text-sm md:text-lg text-center text-white bg-gray-950 rounded-t-lg mx-5 py-3 px-1">
                {{ question.attributes.choices.note }}
            </h4>
            <div class="flex flex-col">
                <div class="questions-enneagram">
                    <div class="agree">
                        <button @click="answer(question.attributes.choices.options[6].save)" class="section font-black">
                            <strong>{{ question.attributes.choices.options[6].display }}</strong>
                        </button>
                        <button @click="answer(question.attributes.choices.options[5].save)" class="section hide font-normal">
                            <strong>{{ question.attributes.choices.options[5].display }}</strong>
                        </button>
                        <button @click="answer(question.attributes.choices.options[4].save)" class="section font-light">
                            <strong>{{ question.attributes.choices.options[4].display }}</strong>
                        </button>
                    </div>
                    <div class="disagree">
                        <button @click="answer(question.attributes.choices.options[3].save)" class="section hide font-normal">
                            <strong>{{ question.attributes.choices.options[3].display }}</strong>
                        </button>
                        <button @click="answer(question.attributes.choices.options[2].save)" class="section font-black">
                            <strong>{{ question.attributes.choices.options[2].display }}</strong>
                        </button>
                        <button @click="answer(question.attributes.choices.options[1].save)" class="section font-black">
                            <strong>{{ question.attributes.choices.options[1].display }}</strong>
                        </button>
                    </div>
                </div>
                <div class="text-center mt-4">
                    <a @click="answer(0)" class="unsure">
                        Can't Decide
                    </a>
                </div>
                <!-- <div class="submit-button-wrapper mt-5">
                    <div v-if="demo !== ('1')">
                        <button @click="answer"
                            type="submit"
                            class="submitResults px-5 py-2"
                            :class="canSave ? 'cursor-pointer' : 'opacity-0'"
                        >
                            Continue <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i>
                        </button>
                    </div>
                    <div v-else>
                      <button @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart Demo<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
                    </div>
                </div> -->

            </div>
        </div>
        <h5 class="hidden md:block opacity-0 text-sm md:text-base text-center text-black bg-gray-400 rounded-md p-3 w-full md:max-w-2xl">
            {{ question.attributes.choices.top }}
        </h5>
    </div>
</template>

<script>
import VTooltip from 'v-tooltip';
import VueSlider from 'vue-slider-component'

export default {
    components: {
      VueSlider
    },

    props: {
        question: {},
    },

    methods: {
        answer(value) {
            this.$emit('answered', String(value));
        },
        sliderChanged () {
            this.canSave = true;
        },
    },

    data() {
      return {
        canSave: false,
        value: 50,
      }
    }
};
</script>
